module.exports = __webpack_public_path__ + "static/img/Cardfooter03.a365049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter03.png
// module id = kqwW
// module chunks = 1